// Attach a single click event listener to the document
document.addEventListener('click', (event) => {
  const { target } = event;

  // Handle open modal buttons
  if (target.classList.contains('open-modal')) {
    const modalId = target.getAttribute('data-modal-target');
    const modal = document.getElementById(modalId);
    if (modal) {
      if(modal.querySelector('.secur-modal-content').classList.contains('full-screen-modal')) {
        document.body.appendChild(modal);
      }
      modal.style.display = 'block';
    }
  }

  // Handle clicking outside the modal content
  if (target.classList.contains('modal-container')) {
    const modalContent = target.querySelector('.modal-content');
    if (!modalContent.contains(event.target)) {
      target.style.display = 'none';
    }
  }

  // Handle close modal buttons
  if (target.classList.contains('close-modal')) {
    const modal = target.closest('.modal-container');
    if (modal) {
      modal.style.display = 'none';
    }
  }
});
